/**
 * SweetAlert2 delete confirmation utility.
 * Provides a reusable confirmation dialog for delete operations.
 */

export interface DeleteConfirmOptions {
    title?: string;
    text?: string;
    confirmButtonText?: string;
    cancelButtonText?: string;
}

const defaultOptions: DeleteConfirmOptions = {
    title: 'Delete Item',
    text: 'Are you sure you want to delete this item? This action cannot be undone.',
    confirmButtonText: 'Yes, delete it!',
    cancelButtonText: 'Cancel'
};

/**
 * Setup delete confirmation for forms with class "form-delete-*"
 */
export function setupDeleteConfirmation(selector: string, options: DeleteConfirmOptions = {}) {
    const deleteForms = document.querySelectorAll<HTMLFormElement>(selector);
    const Swal = (window as any).Swal;
    const opts = { ...defaultOptions, ...options };

    deleteForms.forEach((form) => {
        form.addEventListener('submit', (e: Event) => {
            e.preventDefault();

            if (!Swal) {
                if (confirm(opts.text || 'Are you sure?')) {
                    form.submit();
                }
                return;
            }

            Swal.fire({
                title: opts.title,
                text: opts.text,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#E11D48',
                cancelButtonColor: '#6B7280',
                confirmButtonText: opts.confirmButtonText,
                cancelButtonText: opts.cancelButtonText
            }).then((result: any) => {
                if (result.isConfirmed) {
                    form.submit();
                }
            });
        });
    });
}
